// Single Firebase init shared across the app (avoids multiple initializeApp calls).
// Firebase JS SDK v10, ESM modules from the gstatic CDN — no bundler, no npm.
import { initializeApp } from 'https://www.gstatic.com/firebasejs/10.14.1/firebase-app.js';
import { getAuth, initializeAuth, browserSessionPersistence } from 'https://www.gstatic.com/firebasejs/10.14.1/firebase-auth.js';
import {
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager, memoryLocalCache,
} from './fb/firestore.js';
import { firebaseConfig } from './config.js';

// A SUPPORT TAB (admin console › Support access, 23/10/2026; support-view.js):
// the tab the console opens to view a company read-only. It runs on its OWN
// Firebase app with THIS-TAB-ONLY sign-in (sessionStorage) and an in-memory
// cache, so the platform admin's own session in their other tabs is untouched
// and nothing of the company stays on disk. Every other tab is exactly as before.
export const SUPPORT_TAB = (() => {
  try { return location.pathname === '/support-view' || sessionStorage.getItem('track.supportTab') === '1'; } catch (_) { return false; }
})();

export const app = SUPPORT_TAB ? initializeApp(firebaseConfig, 'track-support') : initializeApp(firebaseConfig);
export const auth = SUPPORT_TAB ? initializeAuth(app, { persistence: browserSessionPersistence }) : getAuth(app);
// Project metadata remains available when a site has no signal. This is the
// supported multi-tab IndexedDB cache; sign-out still gates UI/auth access.
export const db = SUPPORT_TAB ? initializeFirestore(app, { localCache: memoryLocalCache() }) : initializeFirestore(app, {
  // 200 MB, not the SDK's default 40 (25/09). The on-disk cache measured 34 MB
  // against that default, so LRU eviction was about to start — and an evicted
  // document is indistinguishable from one that never existed when you ask the
  // cache a query. Everything local-first in db.js reads that distinction, so
  // eviction would quietly turn "your invoices are not downloaded" into "this
  // project has no invoices".
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
    cacheSizeBytes: 200 * 1024 * 1024,
  }),
});
